import axios from 'axios';
import config from '../config/env.config';

const API_URL = config.API_URL;

// Configure axios for httpOnly cookies
const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true, // Include httpOnly cookies
});

export const groupService = {
  getGroups: () => {
    console.log('Calling API:', `${API_URL}/groups`);
    return apiClient.get('/groups');
  },

  getGroup: (id: string) => {
    return apiClient.get(`/groups/${id}`);
  },

  createGroup: (data: { name: string; description: string; private: boolean }) => {
    return apiClient.post('/groups', data);
  },

  updateGroup: (id: string, data: { name?: string; description?: string; private?: boolean }) => {
    return apiClient.put(`/groups/${id}`, data);
  },

  deleteGroup: (id: string) => {
    return apiClient.delete(`/groups/${id}`);
  },

  // Member Management
  getGroupMembers: (id: string, page: number = 1, limit: number = 20, search: string = '') => {
    const params: any = { page, limit };
    if (search) {
      params.search = search;
    }
    return apiClient.get(`/groups/${id}/members`, { params });
  },

  addGroupMember: (id: string, data: { userId: string; role?: 'admin' | 'member' }) => {
    return apiClient.post(`/groups/${id}/members`, data);
  },

  removeGroupMember: (id: string, userId: string) => {
    return apiClient.delete(`/groups/${id}/members/${userId}`);
  },

  updateMemberRole: (id: string, userId: string, role: 'admin' | 'member') => {
    return apiClient.put(`/groups/${id}/members/${userId}/role`, { role });
  },

  // Join Requests
  requestToJoinGroup: (id: string) => {
    return apiClient.post(`/groups/${id}/join`);
  },

  getPendingJoinRequests: (id: string) => {
    return apiClient.get(`/groups/${id}/requests`);
  },

  approveJoinRequest: (id: string, userId: string) => {
    return apiClient.post(`/groups/${id}/requests/${userId}/approve`);
  },

  rejectJoinRequest: (id: string, userId: string) => {
    return apiClient.post(`/groups/${id}/requests/${userId}/reject`);
  },

  // User Role
  getUserRole: (id: string) => {
    return apiClient.get(`/groups/${id}/role`);
  },

  // Join Request Status and Revoke
  getUserJoinRequestStatus: (id: string) => {
    return apiClient.get(`/groups/${id}/join-status`);
  },

  revokeJoinRequest: (id: string) => {
    return apiClient.delete(`/groups/${id}/join`);
  }
};